export const SidebarIdProjectSettings = 'PROJECT_SETTINGS' as const;
